export const useResponsive = defineStore('responsive', () => {
  const isPad = ref(false)

  const currentInnerWidth = ref(window.innerWidth)

  const handleResize = () => {
    currentInnerWidth.value = window.innerWidth
    if (window.innerWidth < 1600) {
      isPad.value = true
    } else {
      isPad.value = false
    }
    document.body.style.setProperty('--page-height', `${window.innerHeight}px`)
  }

  /** 此1200是根据设计稿来的，设计稿是1200px，所以小于1200就是移动端 */
  const isMobile = computed(() => currentInnerWidth.value < 1200)

  const isUserCenterMobile = computed(() => currentInnerWidth.value < 1460)

  const userCenterMobileParams = computed(() => {
    let isMobile = false
    const asideMenuWidth = 260
    let mobileWidth = 1460
    isMobile = currentInnerWidth.value < 1200 + asideMenuWidth
    mobileWidth = 1200 + asideMenuWidth
    return {
      isMobile: isMobile,
      mobileWidth: mobileWidth,
    }
  })

  onBeforeMount(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  return { isPad, isMobile, isUserCenterMobile, userCenterMobileParams }
})
